// @ts-nocheck
import { motion } from 'framer-motion';
import { Text, XStack, YStack } from 'tamagui';

import { useIsMobile } from '../../hooks/useIsMobile';
import { useMotion } from '../../hooks/useMotion';
import { HOW_IT_WORKS } from './constants';

/**
 * ARRANGE: Numbered step list instead of card grid.
 * Left-aligned step number + title + description in a single column.
 * Feels like a checklist, not a brochure.
 */
export function HowItWorks() {
  const isMobile = useIsMobile();
  const { sectionReveal } = useMotion();

  return (
    <YStack
      paddingVertical={isMobile ? 80 : 100}
      paddingHorizontal="$5"
    >
      <YStack maxWidth={640} alignSelf="center" width="100%">
        <motion.div
          {...sectionReveal}
          viewport={{ once: true, margin: '-100px' }}
        >
          <YStack gap="$3" marginBottom="$8">
            <Text
              fontSize="$2"
              fontWeight="600"
              color="$color7"
              textTransform="uppercase"
              letterSpacing={1.5}
            >
              How it works
            </Text>
            <Text
              fontSize={isMobile ? 30 : 40}
              fontWeight="700"
              letterSpacing={-1.5}
              lineHeight={isMobile ? 36 : 48}
              color="$color12"
            >
              Up and running in minutes
            </Text>
          </YStack>
        </motion.div>

        <YStack gap="$8">
          {HOW_IT_WORKS.map((item, index) => (
            <motion.div
              key={item.step}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.12, duration: 0.4, ease: [0.25, 1, 0.5, 1] }}
            >
              <div style={{ display: 'flex', flexDirection: 'row', gap: 20, alignItems: 'flex-start' }}>
                {/* Step number */}
                <Text
                  fontSize={isMobile ? 36 : 48}
                  fontWeight="700"
                  color="$color4"
                  letterSpacing={-2}
                  lineHeight={isMobile ? 36 : 48}
                  style={{ flexShrink: 0, width: isMobile ? 48 : 68 }}
                >
                  {item.step}
                </Text>
                <YStack gap="$2" style={{ flex: 1, minWidth: 0 }}>
                  <Text fontSize={isMobile ? 18 : 20} fontWeight="600" color="$color12" letterSpacing={-0.3}>
                    {item.title}
                  </Text>
                  <Text fontSize={15} color="$color8" lineHeight={24}>
                    {item.description}
                  </Text>
                </YStack>
              </div>
            </motion.div>
          ))}
        </YStack>
      </YStack>
    </YStack>
  );
}
